// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"634":"a0a1df56","874":"0df00e58"}[chunkId] + ".chunk.js";
};